import { useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useRefin } from '@/providers/refin';
import { prettyFloatMoney } from '@/helpers/utils';
import { REFIN_STATUSES } from '@/helpers/constants';
import { prettyDate } from '@/helpers/date';
import IconArrow from './icon_arrow.svg';
import s from './index.module.scss';

export const Table = ({ repayment, className }) => {
  const { onApply } = useRefin();
  const { t } = useTranslation('next-repayment');
  const [openRows, setOpenRows] = useState([]);

  return (
    <div className={classnames(s.wrapper, className)}>
      <div className={classnames(s.thead, 'f-label', 'table_thead')}>
        <div className={s.row}>
          <div className={s.cell}>{t('table.fundraising')}</div>
          <div className={s.cell}>{t('table.principal')}</div>
          <div className={s.cell}>{t('table.flat_fee')}</div>
          <div className={s.cell}>{t('table.sum')}</div>
          <div className={s.cell}>{t('table.refinancing')}</div>
        </div>
      </div>
      <div className={classnames(s.tbody, 'f-body')}>
        {repayment.fundraisings.map(item => {
          const isAvailable = item.refinancing?.status === REFIN_STATUSES.available;
          const isApplied = item.refinancing?.status === REFIN_STATUSES.applied;

          return (
            <>
              <div className={s.row} key={item.fundraising_name}>
                <div className={classnames(s.cell, isApplied && s.cell_applied)}>
                  <span className="f-small-accent" style={{ whiteSpace: 'nowrap' }}>
                    {item.fundraising_name}
                  </span>
                  {!!item.payments.length && (
                    <button
                      type="button"
                      onClick={() => {
                        setOpenRows(
                          openRows.includes(item.fundraising_name)
                            ? openRows.filter(i => i.fundraising_name === item.fundraising_name)
                            : [...openRows, item.fundraising_name],
                        );
                      }}
                      className={classnames(
                        s.btn_dropdown,
                        openRows.includes(item.fundraising_name) && s.btn_dropdown__active,
                      )}
                    >
                      <img src={IconArrow} alt="arrow" width={12} height={12} />
                    </button>
                  )}
                </div>
                <div className={classnames(s.cell, isApplied && s.cell_applied)}>
                  {prettyFloatMoney(item.principal)}
                </div>
                <div className={classnames(s.cell, isApplied && s.cell_applied)}>
                  {prettyFloatMoney(item.flat_fee)}
                </div>
                <div className={classnames(s.cell, isApplied && s.cell_applied)}>
                  {prettyFloatMoney(item.flat_fee + item.principal)}
                </div>
                <div className={s.cell}>
                  {isAvailable && (
                    <div className={s.refin_available}>
                      <span className="f-small-regular">{t('table.refinance_available')}</span>
                      <button type="button" onClick={() => onApply(item)}>
                        {t('table.apply_now')}
                      </button>
                    </div>
                  )}
                  {isApplied && (
                    <span className="f-small-regular">
                      {t('table.you_have_applied_for_refinance')}
                    </span>
                  )}
                </div>
              </div>
              {openRows.includes(item.fundraising_name) &&
                item.payments.map(payment => (
                  <div className={s.row} key={item.original_deadline}>
                    <div className={classnames(s.cell, isApplied && s.cell_applied)}>
                      <span
                        className="f-small-regular"
                        style={{ whiteSpace: 'nowrap', textAlign: 'right', width: '100%' }}
                      >
                        {prettyDate(payment.original_deadline)}
                      </span>
                    </div>
                    <div className={classnames(s.cell, isApplied && s.cell_applied)}>
                      {prettyFloatMoney(payment.principal)}
                    </div>
                    <div className={classnames(s.cell, isApplied && s.cell_applied)}>
                      {prettyFloatMoney(payment.flat_fee)}
                    </div>
                    <div className={classnames(s.cell, isApplied && s.cell_applied)}>
                      {prettyFloatMoney(payment.flat_fee + payment.principal)}
                    </div>
                    <div className={s.cell} />
                  </div>
                ))}
            </>
          );
        })}
      </div>
    </div>
  );
};
